<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>查看订单信息
    </div>
    <div class="content">
      <div class="set_wrap">
        <el-form ref="form" :model="formdata" label-width="120px">
          <el-form-item label="订单号：">{{ formdata.order_sn }}</el-form-item>
          <el-form-item label="订单状态：">{{
            formdata.order_status
          }}</el-form-item>
          <el-form-item label="订单金额：">{{
            formdata.order_amount
          }}</el-form-item>
          <el-form-item label="订单产品：">
            <div class="table_wrap">
              <el-table :data="formdata.list" style="width: 100%">
                <el-table-column
                  prop="goods_name"
                  label="商品名称"
                ></el-table-column>
                <el-table-column label="商品图片">
                  <template slot-scope="scope">
                    <div class="td_img">
                      <img :src="scope.row.goods_thumb" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="定制图片">
                  <template slot-scope="scope">
                    <div class="td_img">
                      <!-- <img :src="formdata.make_image" /> -->
                      <el-image
                        style="width: 100px; height: 100px"
                        :src="formdata.make_image"
                        :preview-src-list="formdata.make_image"
                      >
                      </el-image>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="价格"></el-table-column>
                <el-table-column
                  prop="number"
                  label="商品数量"
                ></el-table-column>
                <el-table-column label="合计">
                  <template slot-scope="scope">{{
                    scope.row.price * scope.row.number
                  }}</template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item label="收货人信息：">
            {{ formdata.shipping_name }}
            <span>{{ formdata.shipping_phone }}</span>
            {{ formdata.address }}
          </el-form-item>
          <el-form-item
            v-if="formdata.shipping_code != ''"
            label="物流名称："
            >{{ formdata.shipping_id }}</el-form-item
          >
          <el-form-item v-if="formdata.shipping_id != ''" label="物流单号：">{{
            formdata.shipping_code
          }}</el-form-item>
          <el-form-item>
            <el-button @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api.js";

export default {
  name: "employeeDetail",

  data() {
    return {
      formdata: {
        order_sn: "",
        order_status: "",
        order_amount: "",
        list: [],
        shipping_name: "",
        address: "",
        shipping_phone: "",
        shipping_code: "",
        shipping_id: "",
        make_image: [""],
      },
    };
  },
  created() {
    this.orderid = this.$route.query.id;
    this.queryorderedetail();
  },
  methods: {
    // 查询订单详情
    queryorderedetail() {
      let params = {
        order_id: this.orderid,
      };
      this.axios
        .post(api.order_detail, params)
        .then((response) => {
          if (response.data.code == 0) {
            this.formdata.order_sn = response.data.info.order_sn;
            this.formdata.order_status = response.data.info.order_status;
            this.formdata.order_amount = response.data.info.order_amount;
            this.formdata.list = response.data.list || [];
            this.formdata.shipping_name = response.data.info.shipping_name;
            this.formdata.address = response.data.info.address;
            this.formdata.shipping_phone = response.data.info.shipping_phone;
            this.formdata.shipping_code = response.data.info.shipping_code;
            this.formdata.shipping_id = response.data.info.shipping_id;
            this.formdata.make_image[0] = response.data.info.make_image;
            console.log(this.formdata.make_image, 1000011);
          } else {
          }
        })
        .catch(() => {});
    },

    goback() {
      this.$router.go(-1);
    },
  },
};
</script>
